import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import { EnderecoResponse, BancosResponse } from 'common/genericTypes';
import { GETEndereco, GETBancos } from 'requests/catalogo';

export interface CatalogoApiState {
  getEndereco(dispatch: Dispatch, cep: string, stackRequest?: boolean): Promise<EnderecoResponse>;
  getBancos(dispatch: Dispatch, stackRequest?: boolean): Promise<BancosResponse>;
}

const catalogoApiInitialState: CatalogoApiState = {
  getEndereco: GETEndereco,
  getBancos: GETBancos,
};

enum CatalogoApiActionType {
  Update = 'catalogoApi/UPDATE',
  Reset = 'catalogoApi/RESET',
}

export const updateCatalogoApi = (state: CatalogoApiState) => {
  return typedAction(CatalogoApiActionType.Update, state);
};

export const resetCatalogoApi = () => {
  return typedAction(CatalogoApiActionType.Reset);
};

type CatalogoApiAction = ReturnType<typeof updateCatalogoApi | typeof resetCatalogoApi>;

export function catalogoApiReducer(
  state: CatalogoApiState = catalogoApiInitialState,
  action: CatalogoApiAction
): CatalogoApiState {
  switch (action.type) {
    case CatalogoApiActionType.Update:
      return { ...action.payload };
    case CatalogoApiActionType.Reset:
      return { ...catalogoApiInitialState };
    default:
      return state;
  }
}
